import React from 'react';
import UserAuthWrapper from './UserAuthWrapper';
import HostDashboard from '@/pages/HostDashboard';

const HostAuthWrapper: React.FC = () => {
    return (
        <UserAuthWrapper
            userType="host"
            tableName="game_hosts"
            redirectPath="/host-dashboard"
            clearPasswordResetFunction="clear_host_password_reset"
        >
            <HostDashboard/>
        </UserAuthWrapper>
    );
};

export default HostAuthWrapper;
